import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";


function Main(props) {
    
    const [activeIndex, setActiveIndex] = useState(props.activeIndex);

    const handleToggle = (index) => {
       
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const ProjectPositions = 

    [ 
        // File storing 2026 folder

        {
            AdvertisementDate: <> 28.10.2026  </>,
            NameofthePost: <>Communication and Analytics Manager  - (01 Position) <br/>Junior Multimedia Specialist - (01 Position) </> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCDO2026-27024.pdf",
                Text: "Applications are invited from interested candidates for the positions of Communication and Analytics Manager and Junior Multimedia Specialist for a period of one year on contractual basis for the CDO Office at IIT Tirupati. - Advt./ IITT/CDO/2026-27/024",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCDO2026-27024_application_Communication_and_Analytics_Manager.pdf",
                    Text: "Communication and Analytics Manager  ",
                    glowstatus : "yes"
                },
                {
                    Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCDO2026-27024_application_Junior_Multimedia_Specialist.pdf",
                    Text: "Junior Multimedia Specialist",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <>18-11-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 27.10.2026  </>,
            NameofthePost: <>Junior Executive (Accounts)  - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2712.pdf",
                Text: "The Centre for Sponsored Research and Consultancy (CSRC) at the Indian Institute of Technology Tirupati (IITT) invites applications for the position of Junior Executive.  -  Advt/IITT/CSRC/26-27/12",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HNHdXTm1ru7Zpyr67",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <>10-11-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 31.08.2026  </>,
            NameofthePost: <>Research Associate - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2711_Extension.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Research Associate in a time bound National Quantum Mission (NQM) sponsored project by the Department of Science and Technology (DST) undertaken in the Department of Physics.  -  Advt/ IITT/CSRC/26-27/11  ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: " https://forms.gle/JKeh3TugCdnqWRGT6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> <s>14-09-2026</s> extended upto 21-09-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 31.08.2026  </>,
            NameofthePost: <>Research Associate - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2710.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Research Associate in a time bound National Quantum Mission (NQM) sponsored project by the Department of Science and Technology (DST) undertaken in the Department of Physics. - Advt/IITT/CSRC/26-27/10 ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: " https://forms.gle/5VZhYizuHszgV4QbA",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 14-09-2026   </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 22.07.2026  </>,
            NameofthePost: <>Junior Research Fellow- 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2709_Extension.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Junior Research Fellow in an Indian Space Research Organisation (ISRO) sponsored project undertaken in the Department of Chemical Engineering..   -  Advt/ IITT/CSRC/26-27/09   ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/wZa7WXQgtcH1WqEB9 ",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 05-08-2026 extended upto 10-08-2026  </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 16.07.2026  </>,
            NameofthePost: <>Junior Research Fellow- 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2708.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Junior Research Fellow in a time bound ANRF sponsored project undertaken in the Department of Electrical Engineering and Department of Physics.   -  Advt/ IITT/CSRC/26-27/08   ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/o9gxSQC6FXLjD9V18",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 31-07-2026   </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
 
        {
            AdvertisementDate: <> 16.07.2026  </>,
            NameofthePost: <>Project Assistant- 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/2026/recruitment/project/AdvtIITTCSRC26-2707.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Project Assistant in a time bound ANRF sponsored project undertaken in the Department of Electrical Engineering and Department of Physics.  - Advt/ IITT/CSRC/26-27/07  ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/o9gxSQC6FXLjD9V18",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 31-07-2026   </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },

        {
            AdvertisementDate: <> 09.07.2026  </>,
            NameofthePost: <>Project Assistant- 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC26-2706.pdf",
                Text: "Applications are invited from eligible Indian nationals for the post of Project Assistant in a ANRF sponsored project undertaken in the Department of Mechanical Engineering - Advt/IITT/CSRC/26-27/06  ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/1bHoXvptnW1cdjxX7 ",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 24-07-2026  </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },

        {
            AdvertisementDate: <> 25.06.2026  </>,
            NameofthePost: <>Junior Research Fellow (JRF)  - 02 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTCSRC26-2705.pdf",
                Text: "Applications are invited from eligible Indian national for the post of Junior Research Fellow in a time bound MoRTH sponsored project undertaken in the Department of Civil & Environmental Engineering - Advt/ IITT/CSRC/26-27/05 ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/3rSuMDCeaoubgEfDA ",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 10-07-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 25.06.2026  </>,
            NameofthePost: <>Junior Research Fellow (JRF)  - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/IITTCSRC26-2704.pdf",
                Text: "Applications are invited from eligible Indian national for the post of Junior Research Fellow (JRF) in a time bound ANRF sponsored project undertaken in the Department of Humanities and Social Sciences - Advt/IITT/CSRC/26-27/04 ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/VUNMACcsUyaq7MJd8 ",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                
            ],
            LastDate: <> 10-07-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 16.06.2026 </>,
            NameofthePost: <>Project Officer  - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC26-2703.pdf",
                Text: "Advertisement for Project Officer in a time-bound ARE&M-sponsored project undertaken in the Department of Chemistry and Electrical Engineering -  Advt/ IITT/CSRC/26-27/03",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/4GZUEVK9eqa9B8qK9 ",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 26-06-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 11.06.2026 </>,
            NameofthePost: <>Junior Research Fellow (JRF) - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC26-2702.pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the Department of Humanities and Social Sciences -  Advt/ IITT/CSRC/26-27/02",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/1g8rNrgqXqSBmjy38",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 26-06-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 01.04.2026 </>,
            NameofthePost: <>Junior Research Fellow (JRF) - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC26-2701.pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering under CSRC Project (On contract basis)- Advt/ IITT/CSRC/26-27/01",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/mfnrz9wvdWPRbxts9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 15-04-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 25.03.2026 </>,
            NameofthePost: <>Post-Doctoral Fellow - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-2642.pdf",
                Text: "Advertisement for Post-Doctoral Fellow position in the Department of Civil and Environmental Engineering under CSRC Project (On contract basis)- Advt/IITT/CSRC/25-26/42",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Qs2PjGCvzQNepbj58",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 09-04-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 05.03.2026 </>,
            NameofthePost: <>Junior Executive - 02 Positions</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-2641.pdf",
                Text: "Advertisement for Junior Executive positions in the CSRC section (On contract basis)- Advt/IITT/CSRC/25-26/41",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/ZQjMVTCsGwnnCe9u5",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 20-03-2026</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC2025-2641_Selected_Candidate_list.pdf",
                    Text: "Selected Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 02.03.2026 </>,
            NameofthePost: <>Project Associate I - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-26-40_05_03_2026_2.pdf",
                Text: "Advertisement for Project Associate I position in the department of Physics under the CSRC - Advt/IITT/CSRC/2025-26/40",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bGNrNKFqsRCCf8oVA",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 17-03-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },

        {
            AdvertisementDate: <> 27.02.2026 </>,
            NameofthePost: <>Chief Manager - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/CSRC-Advt_IITTCSRC2025-26_39.pdf",
                Text: "Advertisement for Chief Manager position in the department of CSRC - Advt/IITT/CSRC/2025-26/39",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Ro6VtNi95kYE7593A",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 13-03-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        
        {
            AdvertisementDate: <> 27.02.2026 </>,
            NameofthePost: <>Project Manager - 01 Position</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/CSRC-Advt_IITTCSRC25-26_38.pdf",
                Text: "Advertisement for Project Manager position - Advt/IITT/CSRC/25-26/38",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/UdDUBrsEEnhro3RL6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 13-03-2026</>,
             Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC2025-2638_Selected_candidate_list.pdf",
                    Text: "Selected Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        
        
        {
            AdvertisementDate: <> 20.02.2026 </>,
            NameofthePost: <>Research Associate III (RA III)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-2637_24_02_26.pdf",
                Text: "Advertisement for Research Associate III (RA III) position in the department of Physics under the CSRC - Advt/IITT/CSRC/25-26/37 ",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/fh3euKfR7hEuG4Cc9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 02-03-2026</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 28.01.2026 </>,
            NameofthePost: <>Junior Research Fellow (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2628(1).pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the department of Chemical Engineering under the CSRC - Advt/IITT/CSRC/25-26/28(1)",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Z64S7Wg6uyiSLuH39",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 10-02-2026 (by 5:00 PM)</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 28.01.2026 </>,
            NameofthePost: <>Junior Research Fellow (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-2634.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/IITT/CSRC/25-26/34",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Ehk9wkbVed5p8RecA",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 12-02-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 28.01.2026 </>,
            NameofthePost: <>Project Associate (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/AdvtIITTCSRC25-2631.pdf",
                Text: "Advertisement for Project Associate position in the Department of Chemical Engineering - Advt/IITT/CSRC/25-26/31",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/uNHXUmvUwqBXkqXp6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 12-02-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 23.01.2026 </>,
            NameofthePost: <>Junior Research Fellow (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Advt_IITTCSRC25-2636.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/IITT/CSRC/25-26/36",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/J1iB3CbCnKNALCy39",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 01-02-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },

        {
            AdvertisementDate: <> 23.01.2026 </>,
            NameofthePost: <>Senior Project Associate / Project Scientist I (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2026/Advt_IITTCSRC25-2635.pdf",
                Text: "Advertisement for Senior Project Associate / Project Scientist I position in the Department of Civil & Environmental Engineering - Advt/IITT/CSRC/25-26/35",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/J1iB3CbCnKNALCy39",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 01-02-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        

        {
            AdvertisementDate: <> 19.12.2025 </>,
            NameofthePost: <>Project Associate/Senior Project Associate – 1 (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2633.pdf",
                Text: "Advertisement for Project Associate /Senior Project Associate – 1 position in the Department of Chemical Engineering - Advt/ IITT/CSRC/25-26/33",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bJaSuNbxq6tkYgEq6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 09-01-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 19.12.2025 </>,
            NameofthePost: <>Project Assistant (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2632.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/IITT/CSRC/25-26/32",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bJaSuNbxq6tkYgEq6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 09-01-2026 </>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 19.12.2025 </>,
            NameofthePost: <>Project Associate I (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2630.pdf",
                Text: "Advertisement for Project Associate I position in the Department of Physics - Advt/IITT/CSRC/25-26/30",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/jdRHvm5ZqCfbsrcs5",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 03-01-2026 </>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2630_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 19.12.2025 </>,
            NameofthePost: <>Principal Project Scientist (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2629.pdf",
                Text: "Advertisement for Principal Project Scientist position in the Department of Physics - Advt/IITT/CSRC/25-26/29",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/gQ95b79gmaHK3PBj9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 03-01-2026 </>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2629_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 18.12.2025 </>,
            NameofthePost: <>Program Manager (CDP Vertical)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTCDO2025-26011_Prgramme_Manager.pdf",
                Text: "Advertisement for Program Manager (CDP Vertical) position in the Office of Competency Development and Outreach (CDO) - IITT/CDO/2025-26/011",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Application_Form_Programme_Manager_IITTCDO2025-26011.pdf",
                    Text: "Click here to download",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 05-01-2026 </>,
            Status:[
                 {
                     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCDO2025-26021_PM_Results.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
                                   
                     },
                {
                     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Advt. IITTCDO2025-26015_PM_Shortlisted.pdf",
                    Text: "List of Provisionally Shortlisted Candidates",
                    // color: {
                    //     color: "darkgreen",
                    //     "text-align": "justify"
                    // },
                    
                                   
                     }
                 ]
        },
        {
            AdvertisementDate: <> 18.12.2025 </>,
            NameofthePost: <>Accounts Executive (01 position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/IITTCDO2025-26012_Accounts_Executive.pdf",
                Text: "Advertisement for Accounts Executive position in the Office of Competency Development and Outreach (CDO) - IITT/CDO/2025-26/012",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                     Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Application_Form_Accounts_Executive_IITTCDO2025-26012.pdf",
                    Text: "Click here to download",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 05-01-2026</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/2026/recruitment/project/IITTCDO2025-26012_Provisionally_Shortlisted_Candidates.pdf",
                    Text: "List of Provisionally Shortlisted Candidates",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 17.12.2025 </>,
            NameofthePost: <>Junior Research Fellow (JRF)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2628_New.pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the department of Chemical Engineering under the CSRC - Advt/IITT/CSRC/25-26/28",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/ZXxVS2RRBrq74jgc6",
                    Text: "Click here to apply",
                    glowstatus : "no"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 05-01-2026 (by 5:00 PM)</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Advt_IITT_CSRC_2025-26_28_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 15.12.2025 </>,
            NameofthePost: <>Research Associate (RA-I) (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Advt_IITTCSRC2025-2627.pdf",
                Text: "Advertisement for Research Associate (RA-I) position in the department of Chemical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/27",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/h27cKEA8PPZtjPT89",
                    Text: "Click here to apply",
                    glowstatus : "no"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 30.12.2025</>,
            Status:[
               {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2627_Selected_candidate list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 03.12.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2626.pdf",
                Text: "Advertisement for Junior Research Fellow position in the department of Civil & Environmental Engineering under the CSRC - Advt/IITT/CSRC/2025-26/26",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/meUPcvjYb4uxLdW17",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 17.12.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 17.11.2025 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2624.pdf",
                Text: "Advertisement for Project Assistant position in the department of Civil & Environmental / Chemical / Mechanical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/24",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/gAKhLSqk16YHKrHe9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 02.12.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 17.11.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2623.pdf",
                Text: "Advertisement for Junior Research Fellow position in the department of Civil & Environmental / Chemical / Mechanical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/23",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/gAKhLSqk16YHKrHe9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 02.12.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 17.11.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2622.pdf",
                Text: "Advertisement for Junior Research Fellow position in the department of Civil & Environmental Engineering under the CSRC - Advt/IITT/CSRC/2025-26/22",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/thEAbH2377A2TATMA",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 02.12.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 29.10.2025 </>,
            NameofthePost: <>Project Scientist I (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025_2621_Rev.pdf",
                Text: "Advertisement for Project Scientist I position in the department of Civil & Environmental Engineering under the CSRC - Advt/IITT/CSRC/2025-26/21",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/LwtvRrsbvHmtAZjq9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> Extended till 24.11.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 24.10.2025 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2620.pdf",
                Text: "Advertisement for Project Associate position in the department of Electrical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/20",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/vb3JWMtT6X8uAri48",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 03.11.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 09.10.2025 </>,
            NameofthePost: <>Project Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2611(1).pdf",
                Text: "Advertisement for Project Manager positions in the Section of Makers lab under the CSRC - Advt/IITT/CSRC/2025-26/11(1)",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/6afDHn3kYzrxBvxe9",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 24.10.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 26.09.2025 </>,
            NameofthePost: <>Project Associate I (03 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2619.pdf",
                Text: "Advertisement for Project Associate I positions in the Department of Physics under the CSRC - Advt/IITT/CSRC/2025-26/19",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/N6bvTXGMau6pNvUY7",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 10.10.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 26.09.2025 </>,
            NameofthePost: <>Research Associate III (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2618.pdf",
                Text: "Advertisement for Research Associate III position in the Department of Physics under the CSRC - Advt/IITT/CSRC/2025-26/18",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/6Z32oSD7ou4He5ND6",
                    Text: "Click here to apply",
                    glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 10.10.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 22.09.2025 </>,
            NameofthePost: <>JRF (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2616.pdf",
                Text: "Advertisement for JRF position in the Department of Chemical and Mechanical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/16",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/gAFTTzGQByXvscFR9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 07.10.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    // glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 16.09.2025 </>,
            NameofthePost: <>JRF (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2617.pdf",
                Text: "Advertisement for JRF position in the Department of Civil & Environmental Engineering under the CSRC - Advt/IITT/CSRC/2025-26/17",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/eZ7DbF7s3m7PVjr67",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 30.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 16.09.2025 </>,
            NameofthePost: <>Project Associate-I (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2614.pdf",
                Text: "Advertisement for Project Associate-I position in the Department of Chemical Engineering under the CSRC - Advt/IITT/CSRC/2025-26/14",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Jdkm9d3jwoPim44V7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 30.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 16.09.2025 </>,
            NameofthePost: <>Research Associate (RA-I) (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2613.pdf",
                Text: "Advertisement for Research Associate (RA-I) position in the Department of Chemical Engineering under CSRC - Advt/IITT/CSRC/2025-26/13",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HMgq1qxYRy673Trq9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <> 30.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
         {
            AdvertisementDate: <> 11.09.2025 </>,
            NameofthePost: <>Programe Manager (01 Position)</> ,
            Advertisement: 
               
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCDO2025-26001.pdf",
                Text: "Advertisement for Programe Manager position in the Office of Competency Development and Outreach - Advt./IITT/CDO/2025-26/001",
                Style: {
                    color: "blue"
                }
                 },
                 
                
            Application: [
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCDO2025-26001_Application.pdf",
                    Text: "Click here to download",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Walk–In-Interview Date / Reporting time : 07.10.2025 (Rescheduled), 10:00 AM</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCDO2025-26008_Result_Programme_Manager.pdf",
                Text: "Selected Candidate list",
                color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
            },
                {
                   Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCDO2025-26002_Corrigendum.pdf",
                   Text: "Corrigendum (Interview date has been rescheduled from 26th September 2025 to 7th October 2025)",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    // glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 04.09.2025 </>,
            NameofthePost: <>JRF/SRF/Project Associate /Project Scientist/ Post doctoral researcher (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2025-2612.pdf",
                Text: "Advertisement for JRF/SRF/Project Associate/Project Scientist/Post doctoral researcher position in the Department of Chemistry - Advt/IITT/CSRC/2025-26/12",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/77Vg823465gk6hyUA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 18.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 26.08.2025 </>,
            NameofthePost: <>Project Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2611.pdf",
                Text: "Advertisement for Project Manager position in the Department of Mechanical Engineering - Advt/IITT/CSRC/25-26/11",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/27x358h6N8DTEFY29",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 26.08.2025 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2610.pdf",
                Text: "Advertisement for Project Associate position in the Department of Mechanical Engineering - Advt/IITT/CSRC/25-26/10",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/27x358h6N8DTEFY29",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 21.08.2025 </>,
            NameofthePost: <>Junior Research Fellowship (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2609.pdf",
                Text: "Advertisement for Junior Research Fellowship position in the Department of Electrical Engineering - Advt/IITT/CSRC/25-26/09",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/Jyy3XV4wJT2ntfTf8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 04.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 21.08.2025 </>,
            NameofthePost: <>Junior Research Fellowship (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2608.pdf",
                Text: "Advertisement for Junior Research Fellowship position in the Department of Civil and Environmental Engineering - Advt/IITT/CSRC/25-26/08",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/ZEUXaDD5pt5ztq2E7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 04.09.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 04.08.2025 </>,
            NameofthePost: <>Junior Research Fellowship (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2607.pdf",
                Text: "Advertisement for Junior Research Fellowship position in the Department of Mathematics and Statistics. - Advt/IITT/CSRC/25-26/07",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/nw9QFTodZnDw96Pg6",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 19.08.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 15.07.2025 </>,
            NameofthePost: <>Project Associate I (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2606.pdf",
                Text: "Advertisement for Project Associate I position in the Department of Physics. - Advt/IITT/CSRC/25-26/06",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/VisXBN9tcapigWPE6",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 15.07.2025 </>,
            NameofthePost: <>Principal Project Scientist (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2605.pdf",
                Text: "Advertisement for Principal Project Scientist position in the Department of Physics. - Advt/IITT/CSRC/25-26/05",
                Style: {
                    color: "blue"
                },
               
            },
            Application: [
                {
                    Link: "https://forms.gle/KaqGnXtcgu1Z8AL3A",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 15.07.2025 </>,
            NameofthePost: <>Research Associate III (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2604.pdf",
                Text: "Advertisement for Research Associate III (RA III) position in the Department of Physics. - Advt/IITT/CSRC/25-26/04",
                Style: {
                    color: "blue"
                }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/QXMxnoyLadRaMKKC6",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 17.06.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2603.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering. - Advt/ IITT/CSRC/25-26/03",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/PW3KUG2UFjJwB7ir9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 12.07.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 21.03.2025 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2554_1.pdf",
                Text: "Advertisement for Project Associate position in the Department of Electrical Engineering - Advt/IITT/CSRC/24-25/54-1",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/TSnj3kBtpUBdjsmFA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 14.05.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 24.04.2025 </>,
            NameofthePost: <>Project Associate (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC25-2602.pdf",
                Text: "Advertisement for Project Associate position in the Department of Mechanical Engineering. - Advt/IITT/CSRC/25-26/02",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RHLZEQJEWvVYDsYRA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.05.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 09.04.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/Advt_IITTCSRC25-2601.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemistry. - Advt/IITT/CSRC/25-26/01",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/V7rXKGNR5KBV1z7j7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 24.04.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 21.03.2025 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2555.pdf",
                Text: "Advertisement for Project Associate position in the Department of Civil and Environmental Engineering. - Advt/IITT/CSRC/24-25/55",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/VtzU2fZJ9bDLhGkG9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 09.04.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 21.03.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2554.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Electrical Engineering - Advt/IITT/CSRC/24-25/54",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/TSnj3kBtpUBdjsmFA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 05.04.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 13.03.2025 </>,
            NameofthePost: <>Research Assistant (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2553.pdf",
                Text: "Advertisement for Research Assistant position in the Department of Humanities and Social Sciences     - Advt/IITT/CSRC/2024-25/53",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/K9U9roHgjkgDduCG8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.03.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 13.03.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2552.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Electrical Engineering - Advt/IITT/CSRC/2024-25/52",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/eeKp9hqRJKP8Nh1h7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.03.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 13.03.2025 </>,
            NameofthePost: <>Project Engineering (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2551.pdf",
                Text: "Advertisement for Project Engineer position in the Department of Electrical Engineering - Advt/IITT/CSRC/2024-25/51",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/eeKp9hqRJKP8Nh1h7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.03.2025</>,
            Status:[
                {
                    Link: "#",
                    Text: "",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 13.03.2025 </>,
            NameofthePost: <>Project Engineer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2550.pdf",
                Text: "Advertisement for Project Engineer position in the Department of Electrical Engineering - Advt/IITT/CSRC/2024-25/50",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RrSM1J4naKsT2pFy5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.03.2025</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC20242550_Shortlisted_list.pdf",
                    Text: "Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                 ]
        },

        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Project Associate I (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2549.pdf",
                Text: "Advertisement for Project Associate I position in the Department of Physics - Advt/IITT/CSRC/24-25/49",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RvH6Fg8p8L4nyvEP7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2549_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2549_Shortlisted_List.pdf",
                    Text: "Shortlisted Candidate List",
                    // color: {
                    //     color: "darkgreen",
                    //     "text-align": "justify"
                    // },
                    // glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Postdoctoral Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2548.pdf",
                Text: "Advertisement for Postdoctoral Fellow position in the Department of Physics - Advt/IITT/CSRC/24-25/48",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/RvH6Fg8p8L4nyvEP7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2548_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"
                    },
                    glowstatus: "yes"
               
                     },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2548_Shortlisted_List.pdf",
                    Text: "Shortlisted Candidate List",
                    // color: {
                    //     color: "darkgreen",
                    //     "text-align": "justify"
                    // },
                    // glowstatus: "yes"
               
                     },
                 ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Scientific Officer / Technical Engineer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2547_Rev_17.pdf",
                Text: "Advertisement for Scientific Officer / Technical Engineer position in the Department of Physics - Advt/IITT/CSRC/24-25/47",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                {
               Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2547_Selected_Candidate_List.pdf",
               Text: "Selected Candidate List",
               color: {
                   color: "darkgreen",
                   "text-align": "justify"
               },
               glowstatus: "yes"
          
                },
                ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Research Associate III (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2546_Rev_17.pdf",
                Text: "Advertisement for Research Associate III position in the Department of Physics - Advt/IITT/CSRC/24-25/46",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                {
               Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2546_Selected_Candidate_List.pdf",
               Text: "Selected Candidate List",
               color: {
                   color: "darkgreen",
                   "text-align": "justify"
               },
               glowstatus: "yes"
          
                },
                ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Junior Research Fellow (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2545_Rev_17.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Physics - Advt/IITT/CSRC/24-25/45",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                {
               Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2545_Selected_Candidate_List.pdf",
               Text: "Selected Candidate List",
               color: {
                   color: "darkgreen",
                   "text-align": "justify"
               },
               glowstatus: "yes"
          
                },
                ]
        },
        {
            AdvertisementDate: <> 11.02.2025 </>,
            NameofthePost: <>Research Intern (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2544_Rev_17.pdf",
                Text: "Advertisement for Research Intern position in the Department of Physics - Advt/IITT/CSRC/24-25/44",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/bk48XoB2oYHGdvqq5",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 26.02.2025</>,
            Status:[
                 {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2544_Selected_Candidate_List.pdf",
                Text: "Selected Candidate List",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                },
                glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 30.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2543.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil and Environmental Engineering - Advt/IITT/CSRC/24-25/43",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/as1JVjPeF96os3EVA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 28.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC2024-2522_REA.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical and Chemical Engineering - Advt/IITT/CSRC/2024-25/22",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/5JkKiR9W2oTZcY776",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 12.02.2025 (5:00 PM By email)</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 21.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2542.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/IITT/CSRC/24-25/42",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/uLso6GUrJqvCqrEQA",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 05.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },

        {
            AdvertisementDate: <> 08.01.2025 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24_2541.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical & Mechanical Engineering - Advt/IITT/CSRC/24-25/41",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HXkGof4UFHR7Hrxu7",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 23.01.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 17.01.2025 </>,
            NameofthePost: <>Project Lab Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2025/AdvtIITTCSRC24-2540_Exe.pdf",
                Text: "Advertisement for Project Lab Assistant position in the Department of Mechanical Engineering - Advt/IITT/CSRC/24-25/40",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/mBTJDkR45j9BNs9i9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 22.02.2025</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
           
                 },
                 ]
        },
        {
            AdvertisementDate: <> 10.12.2024 </>,
            NameofthePost: <>Research Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_24-25_39.pdf",
                Text: "Advertisement for Research Assistant position in the Department of Humanities and Social Sciences - Advt/IITT/CSRC/24-25/39",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/adtHZCVJSFWr3Vde9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 04.12.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2538.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/ IITT/CSRC/2024-25/38",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/9FSnQxc9fjNoS4wT9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 19.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 04.12.2024 </>,
            NameofthePost: <>Project Associate (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2537.pdf",
                Text: "Advertisement for Project Associate position in the Department of Computer Science and Engineering - Advt/ IITT/CSRC/2024-25/37",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/YELcG2vtPckGcexm8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 19.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
       
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Research Assistant / Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2536.pdf",
                Text: "Advertisement for Research Assistant / Project Assistant position in the Department of  Chemical / Mechanical / Civil & Environmental Engineering - Advt/ IITT/CSRC/2024-25/36",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HwbUiYZhbvRxzEDT8",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 26.11.2024 </>,
            NameofthePost: <>Senior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2535.pdf",
                Text: "Advertisement for Senior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/ IITT/CSRC/2024-25/35",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Scientific Administrative Assistant / Field worker (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2534.pdf",
                Text: "Advertisement for Scientific Administrative Assistant / Field worker position in the Department of  Civil & Environmental Engineering and Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/34",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2533.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineering - Advt/IITT/CSRC/2024-25/33",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/dCjctPGqNQCiU2Ki9",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 25.11.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2532.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil & Environmental Engineeringg - Advt/ IITT/CSRC/2024-25/32",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "https://forms.gle/HwbUiYZhbvRxzEDT8 ",
                    Text: "Click here to apply",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 10.12.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: <>Field Investigator (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2531.pdf",
                Text: "Advertisement for Field Investigator position in the Department of Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/31",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 14.10.2024 </>,
            NameofthePost: <>Research Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2530.pdf",
                Text: "Advertisement for Research Assistant position in the Department of Humanities and Social Sciences - Advt/IITT/CSRC/2024-25/30",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.10.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2529.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical and Mechanical Engineering - Advt/IITT/CSRC/2024-25/29",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 27.11.2024</>,
            Status:[
                 {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_2024_25_29_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                }
                // glowstatus: "yes"
          
            
           
        ]
        },
        {
            AdvertisementDate: <> 24.10.2024 </>,
            NameofthePost: <>Project Associate / Senior Project Associate  (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2528.pdf",
                Text: "Advertisement for Project Associate / Senior Project Associate position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/28",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 24.10.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2527.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/27",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 21.10.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2526.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Machanical / Electrical / Computer Science and Engineering - Advt/ IITT/CSRC/2024 -25/26",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 03.11.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Project Officer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2525.pdf",
                Text: "Advertisement for Project Officer position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/25",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected_candidate_list_25.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                     
                },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2525_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    }
                    // glowstatus: ""
                     
                }
            
            
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Assistant Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524.pdf",
                Text: "Advertisement for Assistant Manager position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/24",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected candidate_list_24.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                   
                },
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    }
                    // glowstatus: ""
                   
                }
            
           
        ]
        },
        {
            AdvertisementDate: <> 17.10.2024 </>,
            NameofthePost: <>Project Officer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2523.pdf",
                Text: "Advertisement for Project Officer position in the Center of Excellence (CoE) (SM & EVT) - Advt/IITT/CSRC/2024-25/23",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 07.11.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2524_Selected_candidate_list_23.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                   
                    },
                    glowstatus: "yes"
                },
                 {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2523_Shortlisted_list.pdf",
                    Text: "Provisionally Shortlisted Candidates List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify" 
                }
                // glowstatus: "yes"
            }
            
           
        ]
        },
        {
            AdvertisementDate: <> 03.10.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2522.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical and Mechanical Engineering - Advt./IITT/CSRC/2024-25/22",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 18.10.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 02.09.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2421.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt./IITT/CSRC/2023-24/21",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 17.09.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 13.08.2024 </>,
            NameofthePost: <>Project Associate (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2520.pdf",
                Text: "Advertisement for Project Associate position in the Department of Computer Science Engineering - Advt/IITT/CSRC/2024-25/20",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 28.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 13.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (02 Positions)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2519_Exnd.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/IITT/CSRC/2024-25/19",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended 11.09.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 09.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2518.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/IITT/CSRC/2024-25/18",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 24.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 09.08.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2517.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/17",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 24.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 06.08.2024 </>,
            NameofthePost: <>Project Manager (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2501_7_8_24.pdf",
                Text: "Advertisement for Project Manager position (Innovation, Incubation, IPR, Start up and Industrial relations) at Centre for Sponsored Research and Consultancy (CSRC) - Advt./IITT/CSRC/2024-25/01",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.08.2024</>,
            Status:[
                {
                    Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2501_Selected_candidate_list.pdf",
                    Text: "Selected Candidate List",
                    color: {
                        color: "darkgreen",
                        "text-align": "justify"                    
                    },
                    glowstatus: "yes"
                     
                }
            
        ]
        },
        {
            AdvertisementDate: <> 30.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT-CSRC_2023-24_16.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Computer Science and Engineering - Advt/IITT/CSRC/2023-24/16",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 08.08.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 16.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2415.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical, Civil and Mechanical Engineering - Advt/ IITT/CSRC/2023-24/15",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 15.07.2024 </>,
            NameofthePost: <>Project Assistant Level 1 (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2514.pdf",
                Text: "Advertisement for Project Assistant Level 1 position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/14",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 15.07.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2413.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Eletrical Engineering - Advt/ IITT/CSRC/2023-24/13",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 30.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.07.2024 </>,
            NameofthePost: <>Project Engineer (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/CSRC_23-24_12.pdf",
                Text: "Advertisement for Project Engineer position in the Department of Electrical Engineering - Advt/ IITT/CSRC/2023-24/12",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 27.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 11.07.2024 </>,
            NameofthePost: <>Project Associate  (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITT_CSRC_2024-25_11.pdf",
                Text: "Advertisement for Project Associate position in the Department of Electrical Engineering - Advt/ IITT/CSRC/2024-25/11",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 25.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2510.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Physics - Advt/ IITT/CSRC/2024-25/10",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 26.06.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2023-2409_27_6_24.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Civil and Environmental Engineering - Advt/ IITT/CSRC/2023-24/09",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 11.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 20.06.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt/ IITT/CSRC/2023-24/08 ",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/08",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 02.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 11.06.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2023-2407.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemistry and Chemical Engineering - Advt/ IITT/CSRC/2023-24/07",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 11.07.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 31.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2506.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/06",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 31.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2505.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Humanities and Social Sciences - Advt/ IITT/CSRC/2024-25/05",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 20.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 29.05.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2504.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Mechanical Engineering - Advt/ IITT/CSRC/2024-25/04",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 13.06.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 30.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2503.pdf",
                Text: "Advertisement for Junior Research Fellow position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/03",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 15.05.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 12.04.2024 </>,
            NameofthePost: <>Project Assistant (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/Advt_IITTCSRC2024-2502_Updated.pdf",
                Text: "Advertisement for Project Assistant position in the Department of Chemical Engineering - Advt/ IITT/CSRC/2024-25/02",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : Extended till 01.05.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        },
        {
            AdvertisementDate: <> 03.04.2024 </>,
            NameofthePost: <>Junior Research Fellow (01 Position)</> ,
            Advertisement: {
                Link: "https://files.iittp.ac.in/pdfs/announcements/2024/AdvtIITTCSRC2024-2501.pdf",
                Text: "Advertisement for Junior Research Fellow (JRF) position in the Department of Chemical Engineering - Advt/IITT/CSRC/2024-25/01",
                // Style: {
                //     color: "blue"
                // }
               
            },
            Application: [
                {
                    Link: "#",
                    Text: "Online application is closed",
                    // glowstatus : "yes"
                }
                // {
                //     Link: "https://files.iittp.ac.in/pdfs/recruitment/2024/March/shortlisted/Status_of_Representation_Student_Counsellor.pdf",
                //     Text: "2. Representation Status",
                //     glowstatus : "yes"
                // }
            ],
            LastDate: <>Last date for submission application : 18.04.2024</>,
            Status:[
                 {
                Link: "#",
                Text: <><br/><br/></>,
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            },
            
            {
                Link: "#",
                Text: "",
                color: {
                    color: "darkgreen",
                    "text-align": "justify"
                }
                // glowstatus: "yes"
            }
        ]
        }
          

        

    ]


   
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Project Positions" />
            <section className="project-detail">
                <div className="container">
                    <div className="c-heading">
                        <h1>Project Positions</h1>
                    </div>

                    <Row>
                        <div className="card-body">

                            
                                    <Table bordered responsive className="mt-3 table table-striped">
                                    <thead>
                                        <tr className='c-tablehead'>
                                        <th>
                                        Date
                                            </th>
                                            <th>
                                                Name of the Post
                                            </th>
                                            <th>Advertisement</th>
                                            <th>
                                                Application
                                            </th>
                                            <th>
                                                Last Date
                                            </th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                    
                                    <tbody>
                                        {ProjectPositions.map((item, index) => (
                                            <tr key={index}>
                                                 <td>{item.AdvertisementDate}</td>
                                                <td>{item.NameofthePost}</td>
                                                <td>
                                                    {typeof item.Advertisement === 'string' ? item.Advertisement : (
                                                        <a href={item.Advertisement.Link} style={{ color: (item.Advertisement.Style && item.Advertisement.Style.color) }} target="_blank" >
                                                            {item.Advertisement.Text}
                                                            <span> (Click Here <i className="icon fas fa-file-pdf" style={{color:"red"}}></i>)</span>
                                                        </a>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.Application.map((status, i) => (
                                                        <div key={i}>
                                                            <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} target="_blank" >{status.Text}</a>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td><span><i className="icon fas fa-calendar" style={{color:"steelblue"}}> </i> </span> {item.LastDate}</td>
                                                <td>
                                                    {Array.isArray(item.Status) ? (
                                                        item.Status.map((status, idx) => (
                                                            <div key={idx}>
                                                                <a className={`text-maroon ${status.glowstatus === "yes" ? 'glowing-text' : ''}`} href={status.Link} style={{ color: (status.color || (status.Style && status.Style.color)) }} target="_blank" >
                                                                {status.Text}
                                                                
                                                                </a>
                                                            </div>
                                                        ))
                                                    ) : (
                                                            <a className={`text-marron ${item.Status.glowstatus == "yes" ? 'glowing-text' : ''}`} href={item.Status.Link} style={{ color: (item.Status.Style && item.Status.Style.color) }} target="_blank" >
                                                            {item.Status.Text}
                                                        </a>
                                                    )
                                                    
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                            
                                    </Table>     
                        </div>
   
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
